import React from 'react';
import { Link } from 'react-router-dom';
import ZoeaLogo from '@/components/ZoeaLogo';
import { ArrowLeft } from 'lucide-react';
import { FAQ } from '@/features/landing/landingCopy';

// Route kept; no platform prices, plans or trials are published until the owner approves a pricing policy.
const PRICE_ANSWER = FAQ.items.find((item) => item.q === 'Wat kost Zoea?').a;

const PricingPage = () => (
  <div className="min-h-screen bg-[#F4F1EA] text-[#0E1015]">
    <nav className="border-b border-[#0E1015]/15" aria-label="Hoofdnavigatie">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" aria-label="Zoea, naar de startpagina">
          <ZoeaLogo className="h-11" />
        </Link>
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#2A2D34] hover:text-[#0E1015] transition-colors">
          <ArrowLeft className="w-4 h-4" aria-hidden="true" />
          Terug naar home
        </Link>
      </div>
    </nav>

    <main className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl sm:text-5xl mb-6 font-['Fraunces'] font-light tracking-normal">Wat kost Zoea?</h1>
        <p className="text-lg leading-relaxed text-[#2A2D34]">{PRICE_ANSWER}</p>
        <Link
          to="/#kennismaking"
          className="mt-8 inline-flex min-h-[48px] items-center justify-center rounded-full bg-[#0E1015] px-8 py-3 text-base font-medium text-[#F4F1EA] hover:bg-[#2A2D34]"
        >
          Plan een kennismaking
        </Link>
      </div>
    </main>
  </div>
);

export default PricingPage;
